import React from "react";
import { createPopper } from "@popperjs/core";
import { useStore } from "../../app/stores/store";
import { all_routes } from "../../feature-module/router/all_routes";
import ImageWithBasePath from "../../core/data/img/ImageWithBasePath";
import { useTranslation } from "react-i18next";
import { Link, useLocation } from "react-router-dom";
import { observer } from "mobx-react-lite";

const UserDropdown = () => {

    const routes = all_routes;
    const { t } = useTranslation();
  
    const {
      userStore: { isAdmin, logout, isLoggedIn, user, isCustomer, isPartner, isUser },
    } = useStore();


  // dropdown props
  const [dropdownPopoverShow, setDropdownPopoverShow] = React.useState(false);
  const btnDropdownRef = React.createRef();
  const popoverDropdownRef = React.createRef();
  const openDropdownPopover = () => {
    createPopper(btnDropdownRef.current, popoverDropdownRef.current, {
      placement: "bottom-start",
    });
    setDropdownPopoverShow(true);
  };
  const closeDropdownPopover = () => {
    setDropdownPopoverShow(false);
  };
  return (
    <>
   
        <div className="items-center flex">
             {user.isLoggedIn && (
          <div className="d-flex align-items-center gap-3">
            <span style={{ color: "#cc3093" }}>
              Welcome, {user?.displayName || 'Partner'}
            </span>
          <span className="w-12 h-12 text-sm text-white bg-blueGray-200 inline-flex items-center justify-center">
 {user?.displayName}

          </span>
 

      <Link
                    to="#"
                    onClick={logout}
                    className="flex items-center px-3 py-2 hover:text-[#49bbd8] hover:bg-gray-200 text-gray-700 font-semibold rounded-lg transition-all"
                  >
                    <i className="fa-regular fa-user mr-2 text-lg" />
                    {t("Logout")}
                  </Link>
  </div>
             )}
     
       </div>
    </>
  );
};

export default observer(UserDropdown);
